import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useContext, useEffect, useState } from 'react';
import { Divider, Grid, Paper, Typography } from '@mui/material';
import { UserType } from '../types/types';
import { UserContext } from '../contexts/userContext';
import { useAddOrUpdateUser } from '../hooks/users';
import hash from 'object-hash';
import { useCheckPAss } from '../hooks/useLogin';
import { ClosableTitle } from './DialogTitle';
import { grey } from '@mui/material/colors';
import { IndicatorButton } from './IndicatorButton';


export interface UserProfileEditionProps {
  open: boolean;
  onClose: () => void;
}

interface MutableUser extends UserType {
  prevPass?: string;
  newPass?: string;
}

export default function UserProfileEdition(props:UserProfileEditionProps) {
  const { open, onClose } = props;
  const { user } = useContext(UserContext);
  const [ mutableUsuario, setMutableUsuario ] = useState<MutableUser | undefined>();

  const usuarioApiCall = useAddOrUpdateUser(mutableUsuario, user);
  const checkPass = useCheckPAss({ username: user?.username, password: mutableUsuario?.prevPass });

  useEffect(() =>{
    if (user?._id) setMutableUsuario(user);
  }, [user]);

  const hayCambios = hash(user ?? '') !== hash(mutableUsuario ?? '');

  const passIncorrecto = checkPass.data;
  let passMessage = '';
  if (passIncorrecto) passMessage = 'La contraseña actual no es correcta';

  return (
    <div>
      <Dialog open={open} onClose={onClose} closeAfterTransition >
        <ClosableTitle onClose={onClose} id="UserProfileEdition" transparent={false}>Editar informacion del usuario</ClosableTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                margin="dense"
                id="name"
                label="Nombre"
                type="text"
                fullWidth
                variant="standard"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setMutableUsuario((prev) => ({ ...prev, firstName: (event.target as HTMLInputElement).value as string }));
                }}
                value={mutableUsuario?.firstName ?? ''}
                required
                error={!mutableUsuario?.firstName}
                helperText={!mutableUsuario?.firstName ? 'El Nombre no puede quedar vacio' : ''}
              />
              <TextField
                margin="dense"
                id="apellido"
                label="Apellido"
                type="text"
                fullWidth
                variant="standard"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setMutableUsuario((prev) => ({ ...prev, lastName: (event.target as HTMLInputElement).value as string }));
                }}
                value={mutableUsuario?.lastName ?? ''}
                required
                error={!mutableUsuario?.lastName}
                helperText={!mutableUsuario?.lastName ? 'El Apellido no puede quedar vacio' : ''}
              />
              <TextField
                margin="dense"
                id="email"
                label="Email"
                type="email"
                fullWidth
                variant="standard"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setMutableUsuario((prev) => ({ ...prev, email: (event.target as HTMLInputElement).value as string }));
                }}
                value={mutableUsuario?.email ?? ''}
                required
                error={!mutableUsuario?.email}
                helperText={!mutableUsuario?.email ? 'El email no puede quedar vacio' : ''}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper elevation={3} style={{ padding: 8, marginTop: 16, backgroundColor: grey[100] }}>
                <Typography style={{ color: grey[600], fontSize: 14 }}>Cambiar Contraseña</Typography>
                <Divider />
                <TextField
                  margin="dense"
                  id="password"
                  label="Contraseña Actual"
                  type="password"
                  fullWidth
                  variant="standard"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setMutableUsuario((prev) => ({ ...prev, prevPass: (event.target as HTMLInputElement).value as string }));
                  }}
                  value={mutableUsuario?.prevPass ?? ''}
                  required
                  error={!!passMessage}
                  helperText={!!passMessage ? passMessage : ''}
                />
                <TextField
                  margin="dense"
                  id="password"
                  label="Contraseña nueva"
                  type="password"
                  fullWidth
                  variant="standard"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setMutableUsuario((prev) => ({ ...prev, newPassword: (event.target as HTMLInputElement).value as string }));
                  }}
                  value={mutableUsuario?.newPass ?? ''}
                  required
                  error={!!mutableUsuario?.newPass?.length && mutableUsuario?.newPass?.length < 6}
                  helperText={!!mutableUsuario?.newPass?.length && mutableUsuario?.newPass?.length < 6
                    ? 'La contraseña no puede tener menos de 6 caracteres' : ''}
                />
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {hayCambios && <Button
            variant="contained"
            disabled={usuarioApiCall.isLoading}
            onClick={() =>{
              if (user) setMutableUsuario(user);
            }}
          >
               Descartar
          </Button>}
          <IndicatorButton
            label={'Guardar Cambios'}
            disabled={
              !mutableUsuario?.username
              || !mutableUsuario.lastName
              || !mutableUsuario.firstName
              || !mutableUsuario.email
              || usuarioApiCall.isLoading
            }
            onClick={() => usuarioApiCall.refetch()}
            loading={usuarioApiCall.isLoading }
          />
        </DialogActions>
      </Dialog>
    </div>
  );
}
